import React from 'react';
import Typo from '../typo';

const SelectionPercentage = ({ percentage }) => {
  return (
    <>
      <Typo component='p' className='si-playerSelPtg'>
        {percentage}
      </Typo>
    </>
  );
};

export default SelectionPercentage;
